import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserServicesService {
  neededUrl: any;
  baseUrl:string = environment.driveUrl
  userServiceUrl = environment.userServiceUrl;
  campaignDashboardUrl = environment.campaignDashboardUrl

  constructor(private http : HttpClient) { }

  getCampaignByShortname(shortName:string){
    return this.http.get(this.campaignDashboardUrl + `/campaign/dashbaord/campaign/${shortName}`);
  }

  postWithoutTokens(options){
    
    return this.http.post(this.campaignDashboardUrl + options.purpose , options.data);
  }

  postWithTokens(options){
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      token: localStorage.getItem('token')
    });


   return this.http.post(this.userServiceUrl + options.purpose, options.data , {headers});
  }
  public httpPost(option: any, isAuthRequired: boolean): Observable<{}> {
    
    var httpAuthOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    if (isAuthRequired) {
      httpAuthOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('token')
        })
      };
    }

    

    option.url = this.userServiceUrl+option.purpose;
    console.log(option);
    console.log("URL:",option.url);
    return this.http.post(option.url, option.body, httpAuthOptions);
  }
  getWithoutTokens(options){
    return this.http.get( this.userServiceUrl + options.purpose );
  }

  getWithParamsWithoutTokens(options){
    return this.http.get( this.campaignDashboardUrl + options.purpose + '?emailId='+ options.data.emailId);
  }

  registerUser(shortname,userDTO) {
    return this.http.put(this.baseUrl + `/drive/registration/${shortname}`,userDTO);
  }

}
